import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import 'bootstrap';
import App from './App.vue'

Vue.config.productionTip = false
Vue.use(VueAxios, axios)

Vue.filter('toGross', (netprice, vatrate) => {
    return netprice*(vatrate/100+1);
  }
)

// eslint-disable-next-line no-undef
Vue.prototype.token = token;

new Vue({
  render: h => h(App),
}).$mount('#app')
